import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { explainPaperStyle, explainExampleTitleStyle, explainPaperTitleStyle, explainPaperTextStyle, explainExamplePaperStyle, explainExampleTextStyle, explainExampleImageBoxStyle} from '../../../../styles/commonStyles';

// 연수 메타데이터
export interface TrainingMetadata {
  id: string;
  title: string;
  category: string;
  description: string;
  instructor: string;
  duration: string;
  date: string;
  tags: string[];
  materials: string[];
  status: 'active' | 'completed' | 'upcoming';
  path: string;
}

export const trainingMetadata: TrainingMetadata = {
  id: '1',
  title: '서울교육연수원 AI 에듀테크 연수',
  category: 'ai-edutech',
  description: '교육현장에서 AI 에듀테크를 활용한 수업 설계 및 실습 연수입니다.',
  instructor: '한지호',
  duration: '2시간',
  date: '2025-10-01',
  tags: ['AI', '에듀테크', '수업설계', '교육혁신'],
  materials: ['AIEdutechTraining.tsx', 'AI활용가이드.pdf'],
  status: 'active',
  path: '/teacher-training/digital/AIEdutechTraining'
};

const SetiVibeCodingTraining: React.FC = () => {
  const navigate = useNavigate();
  const exampleRef = useRef<HTMLDivElement>(null);
  const practiceRef = useRef<HTMLDivElement>(null);
  const [isPdfExpanded, setIsPdfExpanded] = useState(false);

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100%', 
      boxSizing: 'border-box', 
      padding: '24px', 
      margin: 0, 
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'auto'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
        <button
          onClick={() => navigate('/teacher-training/training-pages')}
          style={{
            marginRight: '16px',
            padding: '8px 16px',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          ← 돌아가기
        </button>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
          2025 AI 디저털 역량 강화 직무 연수[4기]: 나의 교실, 나의 콘텐츠
        </h1>
      </div>
      <div style={{ 
        marginBottom: '24px', 
        border: '1px solid #ccc', 
        padding: '16px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: 'white'
      }}>
        <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.25rem' }}>
          📚 목차
        </h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{marginBottom: '8px'}}>
            <a href="#연수-개요" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              연수 개요
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#바이브코딩이란" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              바이브코딩이란?
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#바이브코딩의-흐름" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              바이브코딩의 흐름
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#자주-쓰는-도구-소개" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              자주 쓰는 도구 소개
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#주요-활용-도구" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              주요 활용 도구
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#공유하기" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              참여자 공유 게시판
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#수업-적용-사례" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              수업 적용 사례
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#실습-과제" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              실습 과제
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#참고-자료" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              참고 자료
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#만족도-조사" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              연수 만족도 조사
            </a>
          </li>
        </ul>
      </div>
      {/* 연수 소개 */}
      <div style={{ display: 'flex', alignItems: 'end', marginBottom: '24px', gap: '16px' }}>
        <p style={{ color: '#666', margin: 0, fontSize: '1rem', lineHeight: '1.6' }}>
          서울시교육청 선생님들과 함께하는 바이브코딩 연수페이지입니다.<br/>
          AI 도구를 활용하여 빠르고 효율적으로 콘텐츠를 제작하는 바이브코딩의 개념과 실전 활용법을 다룹니다.<br/>
        </p>
      </div>
      {/* 연수 개요 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="연수-개요">
        연수 개요
      </h2>
      <div style={{
        backgroundColor: '#f8f9fa',
        border: '2px solid #667eea',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '16px'
      }}>
        <p style={{ 
          color: '#333', 
          margin: 0, 
          fontSize: '1.125rem', 
          fontWeight: '600',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          📅 연수 일정: 2025년 12월 4일 (목) 17:00 ~ 20:00 (3시간)
        </p>
      </div>
      <p style={{ color: '#666', marginBottom: '8px', fontSize: '1rem', lineHeight: '1.6' }}>
        본 연수는 다음과 같은 내용으로 구성됩니다.
      </p>
      <ul style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <li>
          <b>바이브코딩의 이해</b>: AI 도구를 활용한 새로운 콘텐츠 제작 방식의 이해
        </li>
        <li>
          <b>바이브코딩의 흐름</b>: 아이디어부터 완성까지의 단계별 프로세스 학습
        </li>
        <li>
          <b>주요 도구 실습</b>: Canva, Gemini, Cursor, Antigravity 등 핵심 도구 활용법
        </li>
        <li>
          <b>실제 적용 사례</b>: 교육 현장에서의 바이브코딩 활용 사례 공유
        </li>
      </ul>
      {/* 바이브코딩이란 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="바이브코딩이란">
        바이브코딩이란?
      </h2>
      <p style={{ color: '#666', marginBottom: '8px', fontSize: '1rem', lineHeight: '1.6' }}>
        바이브코딩(Vibe Coding)은 AI 도구를 활용하여 빠르고 효율적으로 콘텐츠를 제작하는 새로운 작업 방식입니다. 
        전통적인 코딩과 달리, 자연어로 AI와 대화하며 원하는 결과물을 만들어내는 '바이브' 중심의 접근법입니다.
      </p>
      <ul style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <li>
          <b>자연어 기반 작업</b>: 복잡한 코드 작성 없이 자연어로 AI와 소통하여 원하는 결과물 생성
        </li>
        <li>
          <b>빠른 프로토타이핑</b>: 아이디어를 즉시 시각화하고 구현할 수 있는 신속한 개발 방식
        </li>
        <li>
          <b>반복적 개선</b>: AI와의 대화를 통해 점진적으로 결과물을 개선하고 완성도 높이기
        </li>
        <li>
          <b>창의적 협업</b>: AI를 파트너로 삼아 인간의 창의성과 AI의 능력을 결합한 협업 방식
        </li>
      </ul>

      {/* 바이브코딩의 흐름 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="바이브코딩의-흐름">
        바이브코딩의 흐름
      </h2>
      <p style={{ color: '#666', marginBottom: '8px', fontSize: '1rem', lineHeight: '1.6' }}>
        바이브코딩은 다음과 같은 단계적 흐름으로 진행됩니다.
      </p>
      <div style={{
        backgroundColor: '#f8f9fa',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '20px',
        marginBottom: '24px'
      }}>
        <ol style={{ color: '#666', margin: 0, paddingLeft: '20px', fontSize: '1rem', lineHeight: '1.8' }}>
          <li style={{ marginBottom: '12px' }}>
            <b>아이디어 구상</b>: 만들고자 하는 콘텐츠나 기능에 대한 초기 아이디어를 정리합니다.
          </li>
          <li style={{ marginBottom: '12px' }}>
            <b>AI와 대화 시작</b>: 자연어로 AI에게 원하는 것을 설명하고 첫 번째 결과물을 요청합니다.
          </li>
          <li style={{ marginBottom: '12px' }}>
            <b>결과 확인 및 피드백</b>: AI가 생성한 결과를 확인하고, 개선이 필요한 부분을 구체적으로 피드백합니다.
          </li>
          <li style={{ marginBottom: '12px' }}>
            <b>반복적 개선</b>: AI와의 대화를 통해 점진적으로 결과물을 개선하고 완성도를 높입니다.
          </li>
          <li style={{ marginBottom: '12px' }}>
            <b>최종 완성</b>: 만족스러운 결과물을 얻을 때까지 반복하며 최종 결과물을 완성합니다.
          </li>
        </ol>
      </div>

      {/* 자주 쓰는 도구 소개 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="자주-쓰는-도구-소개">
        자주 쓰는 도구 소개
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        바이브코딩을 실현하기 위해 자주 사용되는 도구들을 소개합니다.
      </p>
      <ul style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <li>
          <b>AI 챗봇 도구</b>: Gemini, ChatGPT 등 자연어로 대화하며 콘텐츠를 생성하는 도구
        </li>
        <li>
          <b>디자인 도구</b>: Canva AI, Midjourney 등 텍스트로 이미지와 디자인을 생성하는 도구
        </li>
        <li>
          <b>코드 에디터</b>: Cursor, GitHub Copilot 등 AI가 코드를 작성하고 개선하는 도구
        </li>
        <li>
          <b>통합 개발 환경(IDE)</b>: Antigravity, Cursor 등 AI가 코드를 작성하고 웹 애플리케이션을 개발하는 도구
        </li>
        <li>
          <b>협업 도구</b>: Padlet, Notion AI 등 팀원들과 아이디어를 공유하고 협업하는 도구
        </li>
      </ul>
      {/* 주요 활용 도구 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.5rem' }} id="주요-활용-도구">
        주요 활용 도구
      </h2>
      <p style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.6' }}>
        바이브코딩을 실현하기 위한 핵심 도구 4가지를 소개합니다.
      </p>

      {/* 도구 카드 그리드 */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
        gap: '24px',
        marginBottom: '32px'
      }}>
        {/* Canva 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#00C4CC'
          }}>
            🎨 Canva
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            AI 기반 디자인 도구
          </p>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            lineHeight: '1.6'
          }}>
            Canva는 AI를 활용하여 텍스트만으로도 전문적인 디자인을 생성할 수 있는 도구입니다. 
            Magic Design 기능을 통해 수업 자료, 발표 자료, 포스터, 인포그래픽 등을 빠르게 제작할 수 있습니다.
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>Magic Design: 텍스트 입력만으로 디자인 자동 생성</li>
            <li>Magic Write: AI가 텍스트 내용 작성 및 개선</li>
            <li>이미지 생성: 텍스트로 이미지 자동 생성</li>
            <li>템플릿 라이브러리: 다양한 교육용 템플릿 제공</li>
          </ul>
          <a 
            href="https://www.canva.com" 
            target="_blank" 
            rel="noopener"
            style={{
              display: 'block',
              width: '100%',
              padding: '12px 24px',
              backgroundColor: '#00C4CC',
              color: 'white',
              textAlign: 'center',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              marginTop: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#00A0B0';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 196, 204, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#00C4CC';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Canva 열기 →
          </a>
        </div>

        {/* Gemini 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#4285F4'
          }}>
            ✨ Gemini
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            Google의 멀티모달 AI
          </p>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            lineHeight: '1.6'
          }}>
            Gemini는 텍스트, 이미지, 비디오를 동시에 이해하고 처리할 수 있는 멀티모달 AI입니다. 
            수업 자료 개발, 콘텐츠 생성, 이미지 분석 등 다양한 교육 활동에 활용할 수 있습니다.
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>이미지 및 비디오 분석을 통한 수업 자료 개발</li>
            <li>Google Workspace와 연동한 협업 도구</li>
            <li>다양한 형식의 콘텐츠 생성 (텍스트, 코드, 이미지 설명 등)</li>
            <li>실시간 대화를 통한 반복적 개선</li>
          </ul>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            gap: '8px',
            marginTop: 'auto'
          }}>
            <a 
              href="https://gemini.google.com" 
              target="_blank" 
              rel="noopener"
              style={{
                display: 'block',
                width: '100%',
                padding: '12px 24px',
                backgroundColor: '#4285F4',
                color: 'white',
                textAlign: 'center',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1976d2';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(66, 133, 244, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#4285F4';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Gemini 열기 →
            </a>
            <a 
              href="https://aistudio.google.com/" 
              target="_blank" 
              rel="noopener"
              style={{
                display: 'block',
                width: '100%',
                padding: '10px 24px',
                backgroundColor: '#FFF',
                color: '#4285F4',
                textAlign: 'center',
                textDecoration: 'none',
                borderRadius: '8px',
                fontWeight: '500',
                fontSize: '0.875rem',
                border: '2px solid #4285F4',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#E8F0FE';
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(66, 133, 244, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FFF';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              AI Studio 열기 🔬
            </a>
          </div>
        </div>

        {/* Cursor 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#6366F1'
          }}>
            💻 Cursor
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            AI 기반 코드 에디터
          </p>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            lineHeight: '1.6'
          }}>
            Cursor는 AI가 코드를 작성하고 개선하는 기능을 내장한 코드 에디터입니다. 
            자연어로 설명하면 AI가 코드를 생성하고, 기존 코드를 분석하여 개선 사항을 제안합니다.
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>자연어로 코드 작성 요청 및 자동 생성</li>
            <li>기존 코드 분석 및 개선 제안</li>
            <li>버그 찾기 및 수정 제안</li>
            <li>코드 리팩토링 및 최적화</li>
          </ul>
          <a 
            href="https://cursor.sh" 
            target="_blank" 
            rel="noopener"
            style={{
              display: 'block',
              width: '100%',
              padding: '12px 24px',
              backgroundColor: '#6366F1',
              color: 'white',
              textAlign: 'center',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              marginTop: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#4F46E5';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(99, 102, 241, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#6366F1';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Cursor 열기 →
          </a>
        </div>

        {/* Antigravity 카드 */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <h3 style={{ 
            fontSize: '1.25rem', 
            fontWeight: '600', 
            margin: 0,
            color: '#8B5CF6'
          }}>
            🚀 Antigravity
          </h3>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            fontWeight: '500'
          }}>
            Google의 AI 기반 통합 개발 환경(IDE)
          </p>
          <p style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            lineHeight: '1.6'
          }}>
            Antigravity는 Google에서 개발한 AI 기반 통합 개발 환경(IDE)입니다. 
            자연어로 설명하면 AI가 코드를 자동으로 생성하고, 웹 애플리케이션을 빠르게 개발할 수 있는 도구입니다.
          </p>
          <ul style={{ 
            fontSize: '0.875rem', 
            color: '#666', 
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '1.6'
          }}>
            <li>자연어로 웹 애플리케이션 개발 요청</li>
            <li>AI가 코드를 자동 생성하고 실행 환경 제공</li>
            <li>실시간으로 결과 확인 및 수정 가능</li>
            <li>교육용 웹 도구 및 프로젝트 빠른 개발</li>
          </ul>
          <a 
            href="https://antigravity.google/" 
            target="_blank" 
            rel="noopener"
            style={{
              display: 'block',
              width: '100%',
              padding: '12px 24px',
              backgroundColor: '#8B5CF6',
              color: 'white',
              textAlign: 'center',
              textDecoration: 'none',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '1rem',
              transition: 'all 0.3s ease',
              marginTop: 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#7C3AED';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(139, 92, 246, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#8B5CF6';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Antigravity 열기 →
          </a>
        </div>
      </div>

      {/* 공유하기 섹션 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.5rem' }} id="공유하기">
        💬 참여자 공유 게시판
      </h2>
      <p style={{ color: '#666', marginBottom: '24px', fontSize: '1rem', lineHeight: '1.6' }}>
        연수 참여자분들이 공유한 아이디어와 자료입니다. Padlet에서 직접 여러분의 의견도 공유해보세요!
      </p>

      {/* Padlet 보드로 이동 버튼 */}
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <a 
          href="https://padlet.com/sunrin/ai-gemini-canva-ix9zuu4aehfg98pa" 
          target="_blank" 
          rel="noopener"
          style={{
            display: 'inline-block',
            padding: '14px 32px',
            backgroundColor: '#FF4081',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '1.125rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(255, 64, 129, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#E91E63';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(255, 64, 129, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#FF4081';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(255, 64, 129, 0.3)';
          }}
        >
          📝 Padlet 보드에서 공유하기 →
        </a>
      </div>

      {/* Padlet 임베드 */}
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '24px',
        marginBottom: '32px'
      }}>
        <h3 style={{ 
          fontSize: '1.125rem', 
          fontWeight: '600', 
          marginBottom: '20px',
          color: '#333'
        }}>
          📝 실시간 공유 게시판
        </h3>
        
        <div style={{
          width: '100%',
          height: '600px',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          overflow: 'hidden'
        }}>
          <iframe 
            src="https://padlet.com/embed/ix9zuu4aehfg98pa"
            frameBorder="0"
            allow="camera;microphone;geolocation"
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            title="연수 참여자 공유 게시판"
          />
        </div>
        
        <p style={{
          marginTop: '12px',
          fontSize: '0.875rem',
          color: '#666',
          textAlign: 'center'
        }}>
          💡 위의 버튼을 클릭하여 게시판을 열어 공유해주세요!
        </p>
      </div>

      {/* 수업 적용 사례 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="수업-적용-사례">
        수업 적용 사례
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        바이브코딩을 활용한 실제 수업 사례를 소개합니다.<br/>
        <ul>
          <li>
            <b>사례 1: Gemini로 맞춤형 문제 제작</b>
            <ul>
              <li>학생 수준을 설명하면 AI가 난이도별 문제 자동 생성</li>
              <li>반복적 대화를 통해 문제를 개선하고 완성도 높이기</li>
              <li>즉각적인 피드백 제공으로 학습 효과 향상</li>
            </ul>
          </li>
          <li>
            <b>사례 2: Canva로 수업 자료 디자인</b>
            <ul>
              <li>수업 주제를 텍스트로 입력하여 시각 자료 자동 생성</li>
              <li>Magic Design으로 인포그래픽, 포스터 등 빠르게 제작</li>
              <li>수업 준비 시간 대폭 단축 및 전문적인 자료 제작</li>
            </ul>
          </li>
          <li>
            <b>사례 3: Antigravity로 교육용 웹 애플리케이션 개발</b>
            <ul>
              <li>자연어로 원하는 웹 애플리케이션 기능을 설명하여 자동 생성</li>
              <li>학생 평가 도구, 퀴즈 생성기, 학습 게임 등 맞춤형 웹 도구 개발</li>
              <li>실시간으로 결과를 확인하고 수정하여 완성도 높이기</li>
            </ul>
          </li>
          <li>
            <b>사례 4: Cursor로 교육용 웹 도구 개발</b>
            <ul>
              <li>자연어로 원하는 기능을 설명하여 웹 도구 자동 생성</li>
              <li>학생 평가 도구, 퀴즈 생성기 등 맞춤형 도구 개발</li>
              <li>코드 수정 없이도 기능 개선 및 확장 가능</li>
            </ul>
          </li>
        </ul>
      </p>
      {/* 실습 과제 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="실습-과제">
        실습 과제
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        연수 중 진행할 실습 과제입니다. 바이브코딩의 흐름을 따라 각 도구를 활용해보세요.<br/>
        <ul>
          <li>
            <b>과제 1: Gemini로 수업 자료 제작하기</b>
            <ul>
              <li>Gemini를 활용하여 자신의 교과 수업 자료 제작</li>
              <li>이미지, 텍스트를 결합한 멀티모달 자료 생성</li>
              <li>AI와의 대화를 통해 자료를 점진적으로 개선하기</li>
            </ul>
          </li>
          <li>
            <b>과제 2: Canva로 시각 자료 디자인하기</b>
            <ul>
              <li>Magic Design을 활용한 수업 자료 디자인 제작</li>
              <li>학생 발표용 템플릿 및 인포그래픽 제작</li>
              <li>AI가 생성한 디자인을 수정하고 개선하기</li>
            </ul>
          </li>
          <li>
            <b>과제 3: Cursor로 간단한 웹 페이지 만들기</b>
            <ul>
              <li>자연어로 원하는 웹 페이지 기능 설명하기</li>
              <li>AI가 생성한 코드를 확인하고 수정하기</li>
              <li>코드 개선 요청을 통해 완성도 높이기</li>
            </ul>
          </li>
          <li>
            <b>과제 4: Antigravity로 웹 애플리케이션 만들기</b>
            <ul>
              <li>자연어로 원하는 웹 애플리케이션 기능을 설명하기</li>
              <li>AI가 생성한 코드와 결과를 확인하고 수정하기</li>
              <li>실제 수업에 활용할 수 있는 웹 도구로 완성하기</li>
            </ul>
          </li>
        </ul>
      </p>
      {/* 참고 자료 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="참고-자료">
        참고 자료
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        바이브코딩 및 AI 도구 활용에 도움이 되는 참고 자료입니다.<br/>
        <ul>
          <li>
            <b>공식 문서 및 가이드</b>
            <ul>
              <li><a href="https://gemini.google.com" target="_blank" rel="noopener">Gemini 공식 사이트</a></li>
              <li><a href="https://www.canva.com/designschool/" target="_blank" rel="noopener">Canva Design School</a></li>
              <li><a href="https://cursor.sh/docs" target="_blank" rel="noopener">Cursor 공식 문서</a></li>
              <li><a href="https://antigravity.google/" target="_blank" rel="noopener">Antigravity 공식 사이트</a></li>
            </ul>
          </li>
          <li>
            <b>교육용 AI 활용 커뮤니티</b>
            <ul>
              <li><a href="https://www.aiforeducation.io/" target="_blank" rel="noopener">AI for Education</a></li>
              <li>교육부 AI 디지털교과서 플랫폼</li>
              <li>Google for Education 커뮤니티</li>
            </ul>
          </li>
          <li>
            <b>추천 튜토리얼 및 자료</b>
            <ul>
              <li>바이브코딩 기초 가이드</li>
              <li>Gemini를 활용한 교육 자료 제작 사례</li>
              <li>Canva AI 디자인 활용 팁</li>
              <li>Cursor로 시작하는 AI 코딩</li>
            </ul>
          </li>
        </ul>
      </p>
      <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.5rem' }} id="만족도-조사">
        연수 만족도 조사
      </h2>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: '32px',
        marginBottom: '32px',
        textAlign: 'center'
      }}>
        <p style={{ 
          color: '#666', 
          marginBottom: '24px', 
          fontSize: '1.125rem', 
          lineHeight: '1.6',
          fontWeight: '500'
        }}>
          금일 연수 이수하시느라 고생 많으셨습니다. 🙏<br/>
          마지막으로 연수 만족도 조사를 부탁드립니다.
        </p>
        <a 
          href="https://docs.google.com/forms/d/e/1FAIpQLSfk3HKVW_-6N301IwlhU8-3hVsEm0FGA0iSSZBNv6FmAsDcBg/viewform" 
          target="_blank" 
          rel="noopener"
          style={{
            display: 'inline-block',
            padding: '16px 48px',
            backgroundColor: '#667eea',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            fontSize: '1.125rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#5a6fd8';
            e.currentTarget.style.transform = 'translateY(-4px)';
            e.currentTarget.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#667eea';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
          }}
        >
          📝 만족도 조사 참여하기 →
        </a>
      </div>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        <b>연수 문의</b><br/>
        추가 문의사항이나 도움이 필요하신 경우 연수 담당자에게 연락해주세요.<br/>
        이메일: jihotech16@outlook.kr
      </p>
    </div>
  );
};

export default SetiVibeCodingTraining;